<template>
<div>
  <el-form style="margin: 20px 40px 0 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="项目名称" prop="">
      <el-input v-model="addEditForm.name" placeholder="请输入项目名称"></el-input>
    </el-form-item>
    <el-form-item label="项目类型" prop="">
      <el-select v-fixZoom v-model="addEditForm.radio" filterable placeholder="请选择" :clearable="true" style="width:100%;" >
        <el-option v-for="item in projectArr" :key="item.index" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 30px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
export default {
  name: 'addEditNurse',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      projectArr: [
        {id: 0, name: '饮食及用药'},
        {id: 2, name: '长者服务'},
        {id: 3, name: '环境卫生'}
      ],
      addEditForm: {
        name: '',
        radio: ''
      },
      addEditRules: {}
    }
  },
  created () {
  },
  methods: {
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {}
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditNurse.vue